export default __webpack_public_path__ + "bcb992079995c2c3cf15469f474795fa.svg";